interface QuickwinTrophyIconProps {
  className?: string;
  onClick?: () => void;
  showBackground?: boolean;
  fillColor?: string;
}

export const QuickwinTrophyIcon = ({
  className,
  onClick,
  showBackground = true,
  fillColor = "#28B6DE",
}: QuickwinTrophyIconProps) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    {showBackground && <rect width="30" height="30" rx="15" fill="#D6F6FF" />}
    <path
      d="M20 9.5H23.625C23.875 9.5 24 9.625 24 9.875V11.8125C24 12.8125 23.5104 13.7812 22.5312 14.7188C21.5729 15.6562 20.3854 16.2292 18.9688 16.4375C18.5521 17.3333 18.0312 18.0312 17.4062 18.5312C16.7812 19.0312 16.1458 19.3438 15.5 19.4688V22.5H18.1875C18.4167 22.5 18.6042 22.5729 18.75 22.7188C18.9167 22.8854 19 23.0833 19 23.3125C19 23.4375 18.9375 23.5 18.8125 23.5H11.1875C11.0625 23.5 11 23.4375 11 23.3125C11 23.0833 11.0729 22.8854 11.2188 22.7188C11.3854 22.5729 11.5833 22.5 11.8125 22.5H14.5V19.4688C14.0833 19.3854 13.6771 19.2292 13.2812 19C12.8854 18.7708 12.4792 18.4375 12.0625 18C11.6667 17.5625 11.3229 17.0417 11.0312 16.4375C9.61458 16.2292 8.41667 15.6562 7.4375 14.7188C6.47917 13.7812 6 12.8125 6 11.8125V9.875C6 9.625 6.125 9.5 6.375 9.5H10V7.875C10 7.625 10.125 7.5 10.375 7.5H19.625C19.875 7.5 20 7.625 20 7.875V9.5ZM7 11.8125C7 12.4792 7.33333 13.1667 8 13.875C8.6875 14.5625 9.54167 15.0417 10.5625 15.3125C10.1875 14.125 10 12.7708 10 11.25V10.5H7V11.8125ZM12.1562 16.375C12.9271 17.7917 13.875 18.5 15 18.5C16.125 18.5 17.0729 17.7917 17.8438 16.375C18.6146 14.9583 19 13.25 19 11.25V8.5H11V11.25C11 13.25 11.3854 14.9583 12.1562 16.375ZM23 11.8125V10.5H20V11.25C20 12.7708 19.8125 14.125 19.4375 15.3125C20.4583 15.0417 21.3021 14.5625 21.9688 13.875C22.6562 13.1667 23 12.4792 23 11.8125Z"
      fill={fillColor}
    />
  </svg>
);
